module.exports = __webpack_public_path__ + "static/img/RCC.3f50d62f.png";